<template>
  <div class="lg:px-20 md:px-12 px-4 lg:py-5 md:py-5 lg:mb-0 md:mb-0 mb-12">
    <div>
      <p class="fsize22 sm-fsize18">
        A series of online workshops facilitated by experts in UK. Expect it to
        run mid morning or afternoons.
      </p>
    </div>
    <div
      class="grid lg:grid-cols-3 lg:grid-cols-3 grid-cols-1 pt-5 lg:gap-12 md:gap-8 gap-6"
    >
      <div class="rounded-lg shadow-lg py-4 px-6 pb-16 relative">
        <div class="items-center">
          <p class="fsize22 sm-fsize18 lh32px font-semibold">
            Poetry Master Class
          </p>

          <p class="sm-fsize14">16th June, 2023</p>
        </div>
        <div class="mt-6">
          <p class="sm-fsize14">
            Work with the art of conversation and speech and find the music and
            the poetry in the patterns and images of everyday language. The
            master class will be facilitated by a renowned global expert.
            <br />
            Workshop Timing: 3:30pm IST<br />
            Register your interest today.
          </p>
        </div>
        <!-- <div class="flex justify-center">
          <div class="absolute bottom-4 m-auto">
            <a href="https://forms.gle/JEUkgToZjR4skUV46" target="_blank">
              <button class="bg-primary text-white px-8 py-1 rounded-md mt-4">
                Register now
              </button></a
            >
          </div>
        </div> -->
      </div>
      <div class="rounded-lg shadow-lg py-4 pb-16 px-6 relative">
        <div>
          <p class="fsize22 sm-fsize18 lh32px font-semibold">
            Dance Master Class
          </p>
          <p class="sm-fsize14">23rd June, 2023</p>
        </div>
        <div class="mt-6">
          <p class="sm-fsize14">
            As carers, we work in close contact with those we look after. Our
            work involves being alert to the sensation of touch.
            <br />
            Touch can be seen as a relationship between two people that involves
            listening and responding – the beginning of a dance.
            <br />
            The masterclass will facilitate this exploration onlilne for all
            caregivers.
            <br />
            Register your interest today.
          </p>
        </div>
        <!-- <div class="flex justify-center">
          <div class="absolute bottom-4 m-auto">
            <a href="https://forms.gle/7vDQE8Qy2kffsRju8" target="_blank">
              <button class="bg-primary text-white px-8 py-1 rounded-md mt-4">
                Register now
              </button></a
            >
          </div>
        </div> -->
      </div>

      <div class="rounded-lg shadow-lg py-4 px-6 pb-16 relative">
        <div>
          <p class="fsize22 sm-fsize18 lh32px font-semibold">Visual Arts</p>
          <p class="sm-fsize14">08th September, 2023</p>
          <!-- <p class="sm-fsize14">14th July, 2023</p> -->
        </div>
        <div class="mt-6">
          <p class="sm-fsize14">
            Art enables us to find ourselves and lose ourselves at the same
            time. Art is not what you see, but what you make others see. Through
            the visual arts we want to honor the invisible acts of caregiving,
            challenge stereotypes associated with it and bring dignity to the
            family caregiver.
            <br />
            Join us as we explore the possibilities. Register for the class.
          </p>
          <p class="sm-fsize14">Workshop Timing: 3:30pm IST</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style>
.h-64px {
  height: 64px;
}
</style>
